
import { Component, Prop, Vue } from 'vue-property-decorator'

export interface SelectableButton<T> {
  id: string
  ariaLabel?: string
  classes?: string[]
  disabled?: boolean
  item?: T
}

/**
 * Shows either a list of selectable buttons or the selected one with a button to change the selection.
 *
 * TODO Consider using this UI for checkout donations, and gift-card/donation events (<AddOneToCart>).
 * @see https://tixtrackteam.slack.com/archives/CN2J3BTK7/p1718299044161009
 *
 * The Vue v2.5 syntax for slots was deprecated in v2.6 and removed in a later version.
 * @see https://v2.vuejs.org/v2/guide/components-slots#Scoped-Slots-with-the-slot-scope-Attribute
 */
@Component({ name: 'SelectableButtons' })
export default class extends Vue {
  @Prop({ required: true })
  value: unknown | undefined

  @Prop({ required: true })
  buttons: SelectableButton<unknown>[]

  @Prop({ default: false })
  showChangeButton: boolean

  @Prop()
  selectedClass: Dict<boolean> | undefined

  onSelect(button: SelectableButton<unknown>): void {
    // Don't allow selection of disabled items
    if (button.disabled) {
      return
    }
    this.$emit('input', button.item)
  }

  onDeselect(): void {
    this.$emit('input', undefined)
  }
}
